/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AdminTalentPoolResponseColor } from './adminTalentPoolResponseColor';
import type { AdminTalentPoolResponseIcon } from './adminTalentPoolResponseIcon';

export interface AdminTalentPoolResponse {
  id: string;
  name: string;
  source: string;
  status: string;
  is_standard: boolean;
  index_alias?: string | null;
  disabled_filter_categories?: string[];
  icon?: AdminTalentPoolResponseIcon;
  color?: AdminTalentPoolResponseColor;
  grant_count: number;
  granted_org_ids: string[];
  created_at: string;
}
